<button mat-flat-button color="primary" (click)="findInStore()">
  {{ 'findCircularsInStore' | translate }}
</button>

<button mat-flat-button color="primary" (click)="findInScope()">
  {{ 'findCircularsInScope' | translate }}
</button>
